import React from 'react';

import { DateTimeInfo } from '../DateTimeInfo';
import { NoData } from 'components/base/NoData';

import { ServiceInformationDto } from 'config/apiFunus/types';
import useCeremonyLocation from 'hooks/useCeremonyLocation';

import '../index.scss';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const CeremonyCell = ({ value }: { value: ServiceInformationDto}) => {
  const { getCeremonyLocation } = useCeremonyLocation(value.city);

  return (
    <React.Fragment>
      <div className="text-align-center">
        {getCeremonyLocation(value.location)?.description || (<NoData />)}
      </div>
      {!value.date && !value.time
        ? <NoData />
        : <DateTimeInfo date={value.date} time={value.date && value.time ? `${value.date} ${value.time}` : ''} />}
    </React.Fragment>
  );
};
